import { memo } from 'react';
import { useCardsService } from './Cards/useCardsService';
import { useOMSDependencies } from './useOMSDependencies';

/** Pulled out of <OMS />, just rendered to call the hooks that set up and propagate data into our core redux stores related to the OMS */
export const OMSDependencies = memo(function OMSDependencies() {
  useCardsService();
  useOMSDependencies();

  return null;
});

export default OMSDependencies;
